import {forOwn, set, cloneDeep} from "lodash";
import {format} from "date-fns";
import {STANDARD_DATE_TIME_FORMAT} from "../../../core/const/datetime";
import {getString, resetObjectValues} from "../../../core/helpers/data";

/**
 * Get output value from input
 * @param {any} input - Input value.
 * @return {*}
 */
export const output = input => {
	let result = cloneDeep(input);

	forOwn(result, (value, key) => {
		// Convert Date object to appropriate date string
		if (value instanceof Date) set(result, key, format(value, STANDARD_DATE_TIME_FORMAT.ISO_DATE_TIME_S));
		
		// Get username value from async select object (<label, value>)
		if (key === 'username') set(result, key, getString(value, 'value'));
	});

	// Set proper empty values expected by the API
	result = resetObjectValues(result);

	return result;
}

/**
 * Get input value from raw data
 * @param {any} data - Raw data.
 * @return {*}
 */
export const input = data => {
	let result = cloneDeep(data);

	forOwn(result, (value, key) => {
		// Generate username async select object (<label, value>) from string value
		if (key === 'username' && typeof value === 'string') set(result, key, {label: value, value});
	});
	
	return result;
}